import {combineReducers} from "redux";
import ThemeReducer from "./Reducers/ThemeReducer";
import DrawerReducer from "./Reducers/DrawerReducer";
import AuthReducer from "./Reducers/AuthReducer";
import SearchInputSlice from "./Reducers/SearchBarSlice";

const rootReducer = combineReducers({
    ThemeReducer,
    DrawerReducer,
    AuthReducer,
    SearchInputSlice
})


export default rootReducer;